// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deice-log-dialog {
    position: fixed;
    inset: 0;
    z-index: 1000;
    /* position: absolute; */
    /* adjust as needed depending on layout */
    /* top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); */
    /* z-index: 50; */
    pointer-events: auto;
    background: rgba(0, 0, 0, 0.4);
    pointer-events: auto;

    display: flex;
    align-items: center;
    justify-content: center;

    .deice-summary-dialog-content {
        background: #fff;
        border: 1px solid #ccc;
        padding: 15px;
        border-radius: 4px;
        min-width: 220px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
        display: grid;
        gap: 20px;
        min-width: 400px;
    }

    .deice-summary-dialog-title {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 6px;
    }

    .deice-summary-dialog-buttons {
        display: flex;
        justify-content: flex-end;
        gap: 6px;
        margin-top: 6px;
    }

    .deice-summary-dialog-close,
    .deice-summary-dialog-confirm {
        padding: 10px;
        font-size: 15px;
        cursor: pointer;
        background: #c44a4a;
        color: #ffffff;
        border: none;
    }

    .date-time-field {
        display: grid;
        grid-template-columns: minmax(220px, 1fr) auto;
        align-items: end;
        /* gap: 12px; */
        width: 100%;
        min-width: 0;
    }

    .date-time-field__label {
        display: flex;
        flex-direction: column;
        gap: 6px;
        min-width: 0;
    }

    .date-time-field__label-text {
        font-size: 15px;
        font-weight: 500;
    }

    .date-time-field__input {
        width: 100%;
        min-width: 0;
        height: 44px;
        padding: 0 12px;
        box-sizing: border-box;
        font: inherit;
    }

    .date-time-field__button {
        min-height: 44px;
        padding: 0 16px;
        white-space: nowrap;
        cursor: pointer;
    }

    label {
        display: flex;
        flex-direction: column;
        gap: 6px;
        font-weight: 400;
    }

    input,
    select,
    textarea {
        box-sizing: border-box;
        width: 100%;
        padding: 10px 12px;
        border: 1px solid #bdbdbd;
        border-radius: 4px;
        font: inherit;
    }
}`, "",{"version":3,"sources":["webpack://./src/web/component/DeicingEcoFilterDialogWindow/styles.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,wBAAwB;IACxB,yCAAyC;IACzC;;uCAEmC;IACnC,iBAAiB;IACjB,oBAAoB;IACpB,8BAA8B;IAC9B,oBAAoB;;IAEpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB;QACI,gBAAgB;QAChB,sBAAsB;QACtB,aAAa;QACb,kBAAkB;QAClB,gBAAgB;QAChB,yCAAyC;QACzC,aAAa;QACb,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,QAAQ;QACR,eAAe;IACnB;;IAEA;;QAEI,aAAa;QACb,eAAe;QACf,eAAe;QACf,mBAAmB;QACnB,cAAc;QACd,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,8CAA8C;QAC9C,gBAAgB;QAChB,eAAe;QACf,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;QACR,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;QACR,gBAAgB;IACpB;;IAEA;;;QAGI,sBAAsB;QACtB,WAAW;QACX,kBAAkB;QAClB,yBAAyB;QACzB,kBAAkB;QAClB,aAAa;IACjB;AACJ","sourcesContent":[".deice-log-dialog {\r\n    position: fixed;\r\n    inset: 0;\r\n    z-index: 1000;\r\n    /* position: absolute; */\r\n    /* adjust as needed depending on layout */\r\n    /* top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%); */\r\n    /* z-index: 50; */\r\n    pointer-events: auto;\r\n    background: rgba(0, 0, 0, 0.4);\r\n    pointer-events: auto;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    .deice-summary-dialog-content {\r\n        background: #fff;\r\n        border: 1px solid #ccc;\r\n        padding: 15px;\r\n        border-radius: 4px;\r\n        min-width: 220px;\r\n        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\r\n        display: grid;\r\n        gap: 20px;\r\n        min-width: 400px;\r\n    }\r\n\r\n    .deice-summary-dialog-title {\r\n        font-size: 18px;\r\n        font-weight: 600;\r\n        margin-bottom: 6px;\r\n    }\r\n\r\n    .deice-summary-dialog-buttons {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        gap: 6px;\r\n        margin-top: 6px;\r\n    }\r\n\r\n    .deice-summary-dialog-close,\r\n    .deice-summary-dialog-confirm {\r\n        padding: 10px;\r\n        font-size: 15px;\r\n        cursor: pointer;\r\n        background: #c44a4a;\r\n        color: #ffffff;\r\n        border: none;\r\n    }\r\n\r\n    .date-time-field {\r\n        display: grid;\r\n        grid-template-columns: minmax(220px, 1fr) auto;\r\n        align-items: end;\r\n        /* gap: 12px; */\r\n        width: 100%;\r\n        min-width: 0;\r\n    }\r\n\r\n    .date-time-field__label {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 6px;\r\n        min-width: 0;\r\n    }\r\n\r\n    .date-time-field__label-text {\r\n        font-size: 15px;\r\n        font-weight: 500;\r\n    }\r\n\r\n    .date-time-field__input {\r\n        width: 100%;\r\n        min-width: 0;\r\n        height: 44px;\r\n        padding: 0 12px;\r\n        box-sizing: border-box;\r\n        font: inherit;\r\n    }\r\n\r\n    .date-time-field__button {\r\n        min-height: 44px;\r\n        padding: 0 16px;\r\n        white-space: nowrap;\r\n        cursor: pointer;\r\n    }\r\n\r\n    label {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 6px;\r\n        font-weight: 400;\r\n    }\r\n\r\n    input,\r\n    select,\r\n    textarea {\r\n        box-sizing: border-box;\r\n        width: 100%;\r\n        padding: 10px 12px;\r\n        border: 1px solid #bdbdbd;\r\n        border-radius: 4px;\r\n        font: inherit;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
